import gql from 'graphql-tag';

const mutation = gql`
  mutation updateScenePlaybackMetadata(
    $sceneId: Int!
    $lastPlaybackPosition: Int!
    $isPlaybackCompleted: Boolean!
  ) {
    mindfulnessBalance {
      scene(sceneId: $sceneId) {
        updateScenePlaybackMetadata(
          lastPlaybackPosition: $lastPlaybackPosition
          isPlaybackCompleted: $isPlaybackCompleted
        ) {
          ... on BasicMutationSuccess {
            code
          }

          ... on UnauthorizedException {
            code
          }

          ... on ValidationException {
            code
            messages
            details {
              fieldName
              messages
            }
          }
        }
      }
    }
  }
`;

export default mutation;
